export default __webpack_public_path__ + "static/IBMPlexSans-Thin-e152892c33d46eaf61fecb2476dc6c20.woff2";